<template>
  <img id="imageAsset" :src="imageAsset"
       :style="{ height: imageHeight,  width: imageWidth, top: imageTop, visibility: imageVisibility}"
       class="iwimage" @load="onImgLoad"/>

</template>

<script>
import functions from "../lib/functions.js";

export default {
  name: "IWImage",
  path: '',
  defaultPath: '',
  props: {},
  data() {
    return {
      imageAsset: '',
      imageHeight: '100%',
      imageWidth: '100%',
      imageTop: 0,
      imageVisibility: 'hidden'
    };
  },
  mounted() {
    this.loadAsset();

    addEventListener("resize", this.setSize);
  },
  beforeDestroy() {
    removeEventListener("resize", this.setSize);
  },
  updated: function () {
    this.$nextTick(function () {
      this.setSize();
    })
  },
  watch: {
    '$store.state.cuePoint': function () {
      const [path, defaultPath] = this.getCurrentPath();
      if (path != this.path || defaultPath != this.defaultPath) {
        this.loadAsset();
      }
    }
  },
  methods: {
    loadAsset() {
      if (
        this.$store.getters.getCuePoint
        && this.$store.getters.getCuePoint.images
        && this.$store.getters.getCuePoint.images.group_id
        && this.$store.getters.getCuePoint.images.file_name
      ) {
        [this.path, this.defaultPath] = this.getCurrentPath();
        this.imageVisibility = 'hidden';
        this.fetchBlob().then((content) => {
          if (content != null) {
            const url = URL.createObjectURL(content);
            this.imageAsset = url;
          } else {
            this.imageAsset = "";
          }
        }).catch(() => {
          this.imageAsset = "";
        })
      }
    },
    download(url, contentType) {
      return new Promise((resolve, reject) => {
        fetch(url, {'Content-Type': contentType})
          .then(response => {
            if (!response.ok) {
              throw new Error('code:' + response.status + " - " + response.statusText);
            } else {
              resolve(response);
            }
          })
          .catch(err => {
            reject(new Error(err))
          });
      });
    },
    getCurrentPath() {
      return [
        this.$store.getters.getContentBasePath + "/" + this.$store.getters.getUniqueID + "/images/" + this.$store.getters.getCuePoint.images.group_id + "/" + this.$store.getters.getCur_lang + "/" + this.$store.getters.getCuePoint.images.file_name,
        this.$store.getters.getContentBasePath + "/" + this.$store.getters.getUniqueID + "/images/" + this.$store.getters.getCuePoint.images.group_id + "/" + this.$store.getters.getDef_lang + "/" + this.$store.getters.getCuePoint.images.file_name
      ]
    },
    async fetchBlob() {
      try {
        let content = await this.download(this.path, 'image/*');
        return content.blob();
      } catch (error) {
        try {
          if (this.defaultPath != this.path) {
            let content = await this.download(this.defaultPath, 'image/*');
            return content.blob();
          } else {
            return null;
          }
        } catch (error) {
          return null;
        }
      }
    },
    onImgLoad() {
      const objectWidth = document.getElementById("imageAsset").width;
      const objectHeight = document.getElementById("imageAsset").height;
      this.imageVisibility = 'visible';
      functions.sendParentResizeEvent(objectWidth, objectHeight);
    },
    setSize() {
      if (window.location === window.parent.location || window.parent[0]?.name !== 'fidogroupIframe' || this.$store.getters.getAuto_resize) {
        const h = window.innerHeight;
        const w = window.innerWidth;
        if (h < (0.5625 * w)) { // 9/16
          this.imageHeight = h + 'px';
          this.imageWidth = (h * 16 / 9) + 'px';
        } else {
          this.imageWidth = w + 'px';
          this.imageHeight = (w * 9 / 16) + 'px';
          this.imageTop = (h / 2) - (parseInt(this.imageHeight, 10) / 2) + 'px';
        }
      }
    }
  }
};

</script>
<style scoped>
.iwimage {
  border: 0px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  display: block;
}
</style>
